import styled, { css } from 'styled-components';

interface IContainer {
  isErrored: boolean;
}

export const Container = styled.div<IContainer>`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  position: relative;

  div {
    display: flex;
  }

  > div > span {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;

    > label {
      color: var(--black-2);
      cursor: pointer;
    }
  }

  input:checked,
  input:not(:checked) {
    display: none;
  }

  input:checked + label,
  input:not(:checked) + label {
    position: relative;
    padding-left: 48px;
    cursor: pointer;
    line-height: 34px;
    display: flex;
  }

  input:checked + label:before,
  input:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 30px;
    height: 30px;
    border: 1px solid var(--gray-d);
    border-radius: 100%;
    background: var(--white);
    ${props =>
      props.isErrored &&
      css`
        border-color: var(--danger);
      `}
  }

  input:checked + label:after,
  input:not(:checked) + label:after {
    content: '';
    width: 20px;
    height: 20px;
    background: var(--info);
    border-radius: 50%;
    position: absolute;
    left: 6px;
    top: 6px;
    transition: all 0.4s ease;
  }

  input:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }

  input:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const WarningText = styled.span`
  color: var(--danger);
  font-weight: 500;
  font-size: 12px;
  text-align: right;
  animation: wiggle 0.8s;
  margin: 0 !important;

  @keyframes wiggle {
    0% {
      transform: translateX(0px);
    }
    33% {
      transform: translateX(10px);
    }
    66% {
      transform: translateX(-10px);
    }
    100% {
      transform: translateX(0px);
    }
  }
`;

export const Label = styled.label`
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  margin-bottom: 10px;
  color: var(--black-2);
`;

export const InputElement = styled.input``;
